import React, { useState, useEffect } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import Select from 'react-select';
import { toast } from 'react-toastify';
import LeaseApiService from '../../../services/apiService';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../../Redux/selecters';
import moment from 'moment/moment';
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import Modal from 'react-bootstrap/Modal';
import { useLocation, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WindowedSelect from 'react-windowed-select';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import { IoIosArrowForward } from "react-icons/io";

const UpdateLeaseReservation = () => {
    const userName = useSelector(getName);
    let navigate = useNavigate()
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const { currencyPrecision } = useCurrency();
    const [FilterTab, setFilterTab] = useState(true);
    const [AgentTab, setAgentTab] = useState(true);
    const [SecondaryTab, setSecondaryTab] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [loading, setloader] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [tanentList, setTanentList] = useState([]);
    const [AgentList, setAgentList] = useState([]);
    const [ManagerList, setManagerList] = useState([]);
    const [BrokerList, setBrokerList] = useState([]);
    const [PackageList, setPackageList] = useState([]);
    const [TypeList, setTypeList] = useState([]);
    const [entries, setEntries] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [remarksList, setRemarksList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const companies = useSelector(getCompany);
    const [unitRent, setUnitRent] = useState(true);
    const [datesEditable, setDatesEditable] = useState(false);
    const [datamsg, etdatamessage] = useState();
    const [msgModal, setmsgModal] = useState(false);
    const [leaseda, setLeaseDat] = useState();
    const onOpenModal = () => setmsgModal(true);
    const onCloseModal = () => setmsgModal(false);
    const [barload, setBarLoad] = useState(false);
    const location = useLocation();
    const leaseData = location.state;

    useEffect(() => {
        SetLeaseData()
    }, []);
    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
        setFormData((prev) => ({ ...prev, transDate: formattedDate }));
    }, []);
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const calculateDaysBetween = (from, to) => {
        const diff = new Date(to) - new Date(from);
        let leaseDate = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return leaseDate + 1;
    };
    useEffect(() => {
        const today = new Date();
        const formatted = formatDate(today); // 'DD-MMM-YYYY'

        setFormData((prev) => ({
            ...prev,
            transDate: formatted,
            periodFrom: formatted,
            periodto: formatted,
            leaseTerm: '1',
        }));
        setDatesEditable(false);
    }, []);

    const SetLeaseData = async () => {
        if (leaseData) {
            setBarLoad(true)
            // drpopDownApi list
            const dropparams = new URLSearchParams();
            dropparams.append('dropdownTypes', 'ReservationProductNames,ReservationTenantNames,ReservationPropertyNames,ReservationSalesPersons,ReservationAgents,ReservationLeaseRemarks,ReservationPropetyManagerNames,ReservationTypes');
            const customerRes = await apiService.getApiParamater('GET_MULTI_DROP_RESERV', `?${dropparams.toString()}`);
            let DB = localStorage.getItem('DataBase')
            let selectCompany = companies?.companies.find((comp) => comp.dataDB === DB)
            const selectedManager = customerRes?.data?.dropdowns?.PropetyManagerNames?.filter(pro => pro?.value === selectCompany?.companyNo);
            setTypeList(customerRes?.data?.dropdowns?.ReservationTypes);
            setPackageList(customerRes?.data?.dropdowns?.ProductNames);
            setBrokerList(customerRes?.data?.dropdowns?.Agents);
            setManagerList(selectedManager);
            setAgentList(customerRes?.data?.dropdowns?.SalesPersons);
            setTanentList(customerRes?.data?.dropdowns?.TenantNames);
            setRemarksList(customerRes?.data?.dropdowns?.LeaseRemarks);
            setPropertyList(customerRes?.data?.dropdowns?.PropertyNames);

            const params = new URLSearchParams();
            params.append('Action', 'GetReservationDetailsByGroupId');
            params.append('GroupId', leaseData?.group_Id || leaseData?.groupId);
            params.append('LeaseNo', leaseData?.lease_No || leaseData?.leaseNo);

            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let leaserec = res?.data?.result?.data
            let agent = customerRes?.data?.dropdowns?.SalesPersons?.find((comp) => comp.text === leaserec?.SalesPerson)
            let broker = customerRes?.data?.dropdowns?.Agents?.find((comp) => comp.text === leaserec?.Agent)
            let saleperson = selectedManager?.find((comp) => comp.text === leaserec?.Exp16)
            let selectedPackage = customerRes?.data?.dropdowns?.ProductNames?.find((comp) => comp.text === leaserec?.Exp17)
            let selectedType = customerRes?.data?.dropdowns?.ReservationTypes?.find((comp) => comp.text === leaserec?.PortableWater)
            // Api Call for Customer1
            setLeaseDat(leaserec)
            const custparams = new URLSearchParams();
            custparams.append('Action', 'GetCustomerDetailsByTenantNo');
            custparams.append('TenantNo', leaserec?.Cust1_No);
            const custRes = await apiService.getApiParamater('GET_RESERV_COMMON', `?${custparams.toString()}`);
            let cust1data = custRes?.data?.result?.data
            // Api Call for customer 2
            const cust2params = new URLSearchParams();
            cust2params.append('Action', 'GetCustomerDetailsByTenantNo');
            cust2params.append('TenantNo', leaserec?.Cust2_No);
            const cust2Res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${cust2params.toString()}`);
            let cust2data = cust2Res?.data?.result?.data
            setTenantDetails({
                ...tenantDetails,
                agent: { label: agent?.text, value: agent?.value },
                broker: { label: broker?.text, value: broker?.value },
                type: { label: selectedType?.text, value: selectedType?.value },
                package: { label: selectedPackage?.text, value: selectedPackage?.value },
                prpManager: { label: saleperson?.text, value: saleperson?.value },
                tanent1: { label: leaserec?.Cust1_Name, value: leaserec?.Cust1_No },
                tanent1Code: { label: leaserec?.Cust1_No, value: cust1data },
                tanent2: { label: leaserec?.Cust2_Name, value: leaserec?.Cust2_No },
                tanent2Code: { label: leaserec?.Cust2_No, value: cust2data },
            });
            if (leaserec) {
                const formattedEntry = {
                    Property: {
                        value: leaserec.Property_Id || "", // → property_Id
                        label: leaserec.Property_Name || "" // → propertyName
                    },
                    Unit: {
                        value: leaserec.Unit_No || "", // → unitNo
                        label: leaserec.Unit_No || ""
                    },
                    reservation: {
                        value: {
                            value: "Reservatoin Remarks",
                            text: leaserec.RentPI_Remarks || "" // → rentPI_Remarks
                        },
                        label: "Reservation Remarks"
                    },

                    remarks2: leaserec.Remarks || "", // → remarks
                    remarks3: leaserec.RentPI_Remarks || "", // → remarks
                    // remarks3: leaserec.RentPI_Remarks || "", // → rentPI_Remarks
                    All_In_Rent: 0,
                    Bedrooms: "", // not available in API
                    Floor: "", // not available in API
                    Installments: leaserec.PaymentTermNoOfChqs || 0, // → paymentTermNoOfChqs
                    LLEMailID: "", // not available in API
                    Landlord: leaserec.Exp1 || "", // → exp1
                    MuncAcNo: "0", // hardcoded
                    PEmail: "", // not in API
                    Parking: "0", // default
                    Parking_Price: leaserec?.ShopFit_Deposit || 0, // → shopFit_Deposit
                    Ref_No: leaserec.Exp8 || "", // → exp8, unitRefNo
                    Rent_Per_Annum: parseFloat(leaserec.RentPerAnnum) || 0, // → rentPerAnnum
                    Rent_Per_period: parseFloat(leaserec.TotalPrice) || 0, // → totalPrice
                    Rent_Per_Month: parseFloat(leaserec.Exp12)?.toFixed(currencyPrecision?.decimalNumbers) || 0, // → rentPI_Years
                    Rent_Per_Day: parseFloat(leaserec.Exp13) ? (parseFloat(leaserec.Exp13) / 30).toFixed(6) : "0",
                    Security_Deposit:
                        Number(leaserec?.Security_Deposit) > 0
                            ? Number(leaserec.Security_Deposit).toFixed(currencyPrecision?.decimalNumbers)
                            : Number(leaserec.Exp12).toFixed(currencyPrecision?.decimalNumbers),
                    Tenant_Commission: parseFloat(leaserec.Leasing_Fee) || 0, // → leasing_Fee
                    Total_Area: parseFloat(leaserec.TotalArea) || 0, // → totalArea
                    Unit_Class: leaserec.Exp7 || "", // → unitClass
                    leaseTerm: leaserec.LeaseTerm?.toString() || "", // → leaseTerm
                    leaseFee: leaserec.Leasing_Fee?.toString() || "", // → leasing_Fee again
                    advanceRent: parseFloat(leaserec.Exp13) || 0, // → exp13
                    electricty: leaserec?.Exp11 || "", // → exp11
                    // electricty: leaserec.DEWA?.trim() || "", // → exp11
                    term: leaserec.Exp19 === "0" ? leaserec.Exp10 : leaserec.Exp19 || "", // → exp10 (e.g., "Less Than Year")
                    month: parseInt(leaserec.Exp14) || 0, // → exp14
                    days: parseInt(leaserec.Exp20) || 0, // → exp14
                    filter: "",
                    serviceCharges: leaserec?.Service_Charge?.toString() || "", // → service_Charge
                    rentFree: leaserec?.Advance, // manually set to advance if needed → advance
                    Rent_Month: parseFloat(leaserec.RentPI_Years) || 0, // → exp12
                    periodFrom: leaserec.Lease_Date || "", // → rentCommencementDate
                    periodto: leaserec.Lease_Expiry || "", // → lease_Expiry
                    transDate: leaserec.Exp4 || "", // → exp4, lease_Date
                    electrictType: leaserec?.Exp17 === "1" ? "Inclusive" : "Exclusive" || "",
                    internet: leaserec?.Exp18 === "1" ? true : false || "",
                };
                setEntries([formattedEntry]);
                setBarLoad(false)
            }
        }
    }
    // Tenant Details where tenant and agents, Broker details stored
    const [tenantDetails, setTenantDetails] = useState({
        tanent1: [],
        tanent1Code: [],
        tanent2: [],
        tanent2Code: [],
        agent: [],
        prpManager: [],
        broker: [],
        package: [],
        type: [],
    });
    // FormData  where Property and Unit  details stored
    const [formData, setFormData] = useState({
        Property: [],
        Unit: [],
        reservation: [],
        remarks1: '',
        remarks2: '',
        remarks3: '',
        internet: false,
        electrictType: '',
        Unit: '',
        All_In_Rent: '',
        Bedrooms: '',
        Floor: '',
        Installments: '',
        LLEMailID: '',
        Landlord: '',
        MuncAcNo: '',
        PEmail: '',
        Parking: '',
        Parking_Price: '',
        Ref_No: '',
        Rent_Per_Annum: '',
        Rent_Per_period: '',
        Rent_Per_Month: '',
        Rent_Per_Day: '',
        Security_Deposit: '',
        Tenant_Commission: '',
        Total_Area: '',
        Unit_Class: '',
        leaseTerm: '1',
        transDate: '',
        periodto: '',
        periodFrom: '',
        leaseFee: '',
        advanceRent: 0,
        electricty: '',
        term: '',
        month: 2,
        days: '',
        rentFree: '',
        filter: '',
        serviceCharges: '',
    });

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    // Customer Change function where store selected customer in TenantDetails State
    const handleCust1Change = async (selectedOption) => {

        if (tenantDetails?.tanent2?.label === selectedOption?.label) {
            toast?.warning(`Primary Tanent Should be Different from Secondary Tanent `)
            return;
        }
        else {
            setTenantDetails({
                ...tenantDetails,
                agent: { label: null, value: null },
                broker: { label: null, value: null },
            });
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let data = res?.data?.result?.data
            const selectedBroker = BrokerList?.find(pro => pro?.text === data?.Agent);
            const selectedAgent = AgentList?.find(pro => pro?.text === data?.SalesPerson);
            setTenantDetails({
                ...tenantDetails,
                tanent1: selectedOption,
                tanent1Code: { label: selectedOption?.value, value: data },
                agent: { label: selectedAgent?.text || "", value: selectedAgent?.value || "" },
                broker: { label: selectedBroker?.text || "", value: selectedBroker?.value || "" },
            });
        }
    }
    const handleCust1CodeChange = async (selectedOption) => {
        if (tenantDetails?.tanent2Code?.label === selectedOption?.label) {
            toast?.warning(`Primary Tanent Should be Different from Secondary Tanent `)
            return;
        }
        else {
            setTenantDetails({
                ...tenantDetails,
                agent: { label: null, value: null },
                broker: { label: null, value: null },
            });
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let data = res?.data?.result?.data
            const selectedBroker = BrokerList?.find(pro => pro?.text === data?.Agent);
            const selectedAgent = AgentList?.find(pro => pro?.text === data?.SalesPerson);

            setTenantDetails({
                ...tenantDetails,
                tanent1: { label: selectedOption?.value, value: selectedOption?.label },
                tanent1Code: { label: selectedOption?.label, value: res?.data?.result?.data },
                agent: { label: selectedAgent?.text || "", value: selectedAgent?.value || "" },
                broker: { label: selectedBroker?.text || "", value: selectedBroker?.value || "" },
            });
        }
    }
    // Joint Customer Change function where store selected customer in TenantDetails State
    const handleCust2Change = async (selectedOption) => {
        if (tenantDetails?.tanent1?.label === selectedOption?.label) {
            toast?.warning(`Secondary Tanent Should be Different from Primary Tanent `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            setTenantDetails({
                ...tenantDetails,
                tanent2: selectedOption,
                tanent2Code: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleCust2CodeChange = async (selectedOption) => {
        if (tenantDetails?.tanent1Code?.label === selectedOption?.label) {
            toast?.warning(`Secondary Tanent Should be Different from Primary Tanent `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            setTenantDetails({
                ...tenantDetails,
                tanent2: { label: selectedOption?.value, value: selectedOption?.label },
                tanent2Code: { label: selectedOption?.label, value: res?.data?.result?.data },
            });
        }
    }
    // Agent Change function where store selected Agent in TenantDetails State
    const handleAgentChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, agent: selectedOption });
    }
    // Property Manager Change function where store selected Property Manager in TenantDetails State
    const handleManagerChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, prpManager: selectedOption });
    }
    // Broker Change function where store selected Broker in TenantDetails State
    const handleBrokerChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, broker: selectedOption });
    }
    // Package Change function where store selected Package in TenantDetails State
    const handlePackageChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, package: selectedOption });
    }
    // Tenant Type Change function where store selected Tenant Type  in TenantDetails State
    const handleTypeChange = (selectedOption) => {
        setTenantDetails({ ...tenantDetails, type: selectedOption });
    }
    // unit funtions
    // Handle change function where i store unit details that entered  in input fields of unit  
    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'Rent_Per_Month') {

            const enteredValue = Number(value || 0);
            const minRent = Number(formData?.Rent_Month || 0);

            // // Prevent less than minimum value
            // if (enteredValue < minRent) {
            //     toast?.warning(`Rent must be greater than or equal to ${minRent}`);

            //     setFormData((prev) => ({
            //         ...prev,
            //         [name]: minRent,
            //     }));

            //     return;
            // }

            setFormData((prev) => ({
                ...prev,
                [name]: enteredValue,
            }));

            const params = new URLSearchParams();
            params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
            params.append('PeriodFrom', formData?.periodFrom);
            params.append('PeriodTo', formData?.periodto);
            params.append('Commontext', enteredValue);

            const res = await apiService.getApiParamater(
                'GET_RESERV_COMMON',
                `?${params.toString()}`
            );

            let result = res?.data?.result?.data?.RentPerAnnum;

            if (result) {
                advanceRentCalculation({ perMonthval: enteredValue });

                setFormData((prev) => ({
                    ...prev,
                    Rent_Per_period: result || 0,
                    Security_Deposit: enteredValue?.toFixed(currencyPrecision?.decimalNumbers) || 0,
                }));
            }

        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };
    const getMonthDiff = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);

        if (endDate < startDate) return 0;

        // Calculate month difference
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months += endDate.getMonth() - startDate.getMonth();

        // Include last month if end day >= start day
        if (endDate.getDate() >= startDate.getDate()) {
            months += 1;
        }

        return months;
    };
    // Addmore function that use for store selected unit and data entered in formData
    const handleAddMore = async () => {
        if (!formData.Property?.label) {
            toast.warning(`Please Select Property`);
            return;
        } else if (!formData.Unit?.label) {
            toast.warning(`Please Select Unit No`);
            return;
        } else if (!formData?.term) {
            toast.warning(`Please select any Lease Term`);
            return;
        } else if (!formData?.periodFrom) {
            toast.warning(`Please select Period From`);
            return;
        } else if (!formData?.periodto) {
            toast.warning(`Please select Period to`);
            return;
        } else if (!formData?.Rent_Per_period) {
            toast.warning(`Please Enter Rent Per Period amount`);
            return;
        } else if (!formData?.Rent_Per_Annum) {
            toast.warning(`Please Enter Rent Per Annum amount`);
            return;
        } else if (!formData?.Unit_Class) {
            toast.warning(`Unit class is unavailable please select another Unit`);
            return;
        }

        const isLease = formData.Unit_Class === 'Lease';
        const isPM = formData.Unit_Class === 'PM';
        const leaseCount = entries.filter(e => e.Unit_Class === 'Lease').length;
        const pmCount = entries.filter(e => e.Unit_Class === 'PM').length;

        // Rule: Do not mix PM and Lease
        if ((isLease && pmCount > 0)) {
            toast.warning(`You cannot add Lease Unit with PM Unit.`);
            return;
        }
        if ((isPM && leaseCount > 0)) {
            toast.warning(`You cannot add PM Unit with Lease Unit.`);
            return;
        }
        // // Rule: Max 2 Lease entries
        // if (isLease && leaseCount >= 2) {
        //     toast.warning(`You can only add up to 2 Lease entries.`);
        //     return;
        // }

        // Rule: Max 1 PM entry
        if (isPM && pmCount >= 1) {
            toast.warning(`You can only add 1 PM entry.`);
            return;
        }
        const checkparams = new URLSearchParams();
        checkparams.append('Action', 'CheckAddunitReservationValidation');
        checkparams.append('PropertyNo', formData.Property?.value);
        checkparams.append('UnitNo', formData.Unit?.label);
        checkparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        checkparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        const checkResponse = await apiService.getApiParamater('GET_RESERV_COMMON', `?${checkparams.toString()}`);

        let checkResult = checkResponse?.data?.result?.data
        if (checkResult?.Cnt >= 1) {
            toast.warning(checkResult?.Msg)
            return;
        } else if (checkResult?.Cnt === 0) {
            const params = new URLSearchParams();
            params.append('Action', 'CheckbookingThroughNavyValidation');
            params.append('PropertyNo', formData.Property?.value);
            params.append('Agent', tenantDetails?.agent?.label || "");
            params.append('SalesPerson', tenantDetails?.broker?.label || "");
            params.append('Commontext', '');
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.Msg
            etdatamessage(result)
            if (res?.data?.result?.data?.Msg === "0") {
                dataset()
            } else {
                onOpenModal()
            }
        }
    };
    const dataset = () => {

        if (!entries[0]?.Property?.label) {
            setEntries(prevEntries => prevEntries.slice(1));
        }
        if (editIndex !== null) {
            const updatedEntries = [...entries];
            updatedEntries[editIndex] = formData;

            setEntries(updatedEntries);
            setEditIndex(null);
        } else {

            setEntries((prev) => [...prev, formData]);
        }
        // Reset form
        const today = new Date();
        const formatted = formatDate(today);
        setDatesEditable(false);

        setFormData({
            Property: [{ label: '', value: '' }],
            Unit: [{ label: '', value: '' }],
            reservation: [],
            remarks1: '',
            remarks2: '',
            remarks3: '',
            internet: false,
            electrictType: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            Installments: '',
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            rentFree: '',
            filter: '',
            serviceCharges: '',
            transDate: formatted,
            periodFrom: formatted,
            periodto: formatted,
            leaseTerm: '1',
        });
        onCloseModal()
    }
    const handleUpdate = async () => {
        const enteredValue = Number(formData?.Rent_Per_Month || 0);
        const minRent = Number(formData?.Rent_Month || 0);
        if (!formData.Property?.label) {
            toast.warning(`Please Select Property`);
            return;
        } else if (!formData.Unit?.label) {
            toast.warning(`Please Select Unit No`);
            return;
        } else if (!formData?.term) {
            toast.warning(`Please select any Lease Term`);
            return;
        } else if (!formData?.periodFrom) {
            toast.warning(`Please select Period From`);
            return;
        } else if (!formData?.periodto) {
            toast.warning(`Please select Period to`);
            return;
        } else if (!formData?.Rent_Per_period) {
            toast.warning(`Please Enter Rent Per Period amount`);
            return;
        } else if (!formData?.Rent_Per_Annum) {
            toast.warning(`Please Enter Rent Per Annum amount`);
            return;
        } else if (!formData?.Unit_Class) {
            toast.warning(`Unit class is unavailable please select another Unit`);
            return;
        } else if (enteredValue < minRent) {
            toast?.warning(`Rent must be greater than or equal to ${minRent}`);
            return;
        }

        const isLease = formData.Unit_Class === 'Lease';
        const isPM = formData.Unit_Class === 'PM';
        const leaseCount = entries.filter(e => e.Unit_Class === 'Lease').length;
        const pmCount = entries.filter(e => e.Unit_Class === 'PM').length;

        // Rule: Do not mix PM and Lease

        // if ((isLease && pmCount > 0)) {
        //     toast.warning(`You cannot add Lease Unit with PM Unit.`);
        //     return;
        // }
        // if ((isPM && leaseCount > 0)) {
        //     toast.warning(`You cannot add PM Unit with Lease Unit.`);
        //     return;
        // }


        // Rule: Max 1 PM entry
        // if (isPM && pmCount >= 1) {
        //     toast.warning(`You can only add 1 PM entry.`);
        //     return;
        // }
        const checkparams = new URLSearchParams();
        checkparams.append('Action', 'CheckUpdateunitReservationValidation');
        checkparams.append('PropertyNo', formData.Property?.value);
        checkparams.append('UnitNo', formData.Unit?.label);
        checkparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        checkparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        const checkResponse = await apiService.getApiParamater('GET_RESERV_COMMON', `?${checkparams.toString()}`);
        let checkResult = checkResponse?.data?.result?.data
        if (checkResult?.Cnt === 0) {
            toast.warning(checkResult?.Msg)
            return;
        } else if (checkResult?.Cnt >= 1) {
            const params = new URLSearchParams();
            params.append('Action', 'CheckbookingThroughNavyValidation');
            params.append('PropertyNo', formData.Property?.value);
            params.append('Agent', tenantDetails?.agent?.label || "");
            params.append('SalesPerson', tenantDetails?.broker?.label || "");
            params.append('Commontext', '');
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.Msg
            etdatamessage(result)
            

            if (res?.data?.result?.data?.Msg === "0") {
                if (editIndex !== null) {
                    const updatedEntries = [...entries];
                    updatedEntries[editIndex] = formData;
                    setEntries(updatedEntries);
                    setEditIndex(null);

                    // Reset form
                    const today = new Date();
                    const formatted = formatDate(today);
                    setDatesEditable(false);

                    setFormData({
                        Property: [{ label: '', value: '' }],
                        Unit: [{ label: '', value: '' }],
                        reservation: [],
                        remarks1: '',
                        remarks2: '',
                        remarks3: '',
                        All_In_Rent: '',
                        Bedrooms: '',
                        Floor: '',
                        Installments: '',
                        LLEMailID: '',
                        Landlord: '',
                        MuncAcNo: '',
                        internet: false,
                        electrictType: '',
                        PEmail: '',
                        Parking: '',
                        Parking_Price: '',
                        Ref_No: '',
                        Rent_Per_Annum: '',
                        Rent_Per_period: '',
                        Rent_Per_Month: '',
                        Rent_Per_Day: '',
                        Security_Deposit: '',
                        Tenant_Commission: '',
                        Total_Area: '',
                        Unit_Class: '',
                        leaseFee: '',
                        advanceRent: 0,
                        electricty: '',
                        term: '',
                        month: 2,
                        days: '',
                        rentFree: '',
                        filter: '',
                        serviceCharges: '',
                        transDate: formatted,
                        periodFrom: formatted,
                        periodto: formatted,
                        leaseTerm: '1',
                    });
                    onCloseModal()
                } else {
                    setEntries((prev) => [...prev, formData]);
                }
            } else {
                onOpenModal()
            }

        }
    }
    const handleEdit = (index) => {
        setFormData(entries[index]);
        setEditIndex(index);
    }
    const handleDelete = (index) => {
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
        if (editIndex === index) {
            setFormData({
                Property: [],
                Unit: [],
                reservation: [],
                remarks1: '',
                remarks2: '',
                remarks3: '',
                Unit: '',
                internet: false,
                electrictType: '',
                All_In_Rent: '',
                Bedrooms: '',
                Floor: '',
                Installments: '',
                LLEMailID: '',
                Landlord: '',
                MuncAcNo: '',
                PEmail: '',
                Parking: '',
                Parking_Price: '',
                Ref_No: '',
                Rent_Per_Annum: '',
                Rent_Per_period: '',
                Rent_Per_Month: '',
                Rent_Per_Day: '',
                Security_Deposit: '',
                Tenant_Commission: '',
                Total_Area: '',
                Unit_Class: '',
                leaseTerm: '1',
                transDate: '',
                periodto: '',
                periodFrom: '',
                leaseFee: '',
                advanceRent: 0,
                electricty: '',
                term: '',
                month: 2,
                days: '',
                filter: '',
                rentFree: '',
                serviceCharges: '',
            });
            setEditIndex(null);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        setUnitList([])
        const params = new URLSearchParams();
        params.append('DropdownFor', 'ResvCreateUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_CASCAD_RESERV', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setFormData({
            Property: selectedOption,
            Unit: [{ label: '', value: '' }],
            reservation: [],
            remarks1: '',
            remarks2: '',
            remarks3: '',
            Unit: '',
            internet: false,
            electrictType: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            Installments: '',
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseTerm: '1',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            filter: '',
            serviceCharges: '',
            rentFree: '',
        });
    }
    const handleRemarksChange = (selectedOption) => {
        setFormData({
            ...formData,
            reservation: selectedOption,
            remarks2: selectedOption?.label === "Lease Agreement Remarks" ? formData?.remarks2 : selectedOption?.value?.text,
            remarks3: selectedOption?.label === "Lease Agreement Remarks" ? selectedOption?.value?.text : formData?.remarks3,
        });
    }
    const handleUnitChange = async (selectedOption) => {
        // handleClearForm()
        const params = new URLSearchParams();
        params.append('Action', 'GetUnitDetailsByPropNoAndUnitNo');
        params.append('UnitNo', selectedOption?.label);
        params.append('PropertyNo', formData?.Property?.value);
        const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
        let data = res?.data?.result?.data
        let rentPerMonth = data?.Rent_Per_Annum / 12
        const Amountparams = new URLSearchParams();
        Amountparams.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
        Amountparams.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
        Amountparams.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
        Amountparams.append('Commontext', rentPerMonth);
        const AmountRes = await apiService.getApiParamater('GET_RESERV_COMMON', `?${Amountparams.toString()}`);
        let result = AmountRes?.data?.result?.data?.RentPerAnnum
        let rentPerDay = result / 360
        setFormData({
            ...formData,
            Unit: selectedOption,
            All_In_Rent: data?.All_In_Rent,
            Bedrooms: data?.Bedrooms,
            Floor: data?.Floor,
            Installments: data?.Installments,
            LLEMailID: data?.LLEMailID,
            Landlord: data?.Landlord,
            MuncAcNo: data?.MuncAcNo,
            PEmail: data?.PEmail,
            Parking: data?.Parking,
            Parking_Price: data?.Parking_Price,
            Ref_No: data?.Ref_No,
            Rent_Per_Annum: data?.Rent_Per_Annum,
            Rent_Per_period: parseFloat(result),
            Rent_Per_Day: rentPerDay || 0,
            Rent_Month: rentPerMonth,
            Rent_Per_Month: rentPerMonth?.toFixed(currencyPrecision?.decimalNumbers),
            Security_Deposit:
                Number(data?.Security_Deposit) > 0
                    ? Number(data.Security_Deposit).toFixed(currencyPrecision?.decimalNumbers)
                    : Number(rentPerMonth).toFixed(currencyPrecision?.decimalNumbers),
            Tenant_Commission: data?.Tenant_Commission,
            Total_Area: data?.Total_Area,
            Unit_Class: data?.Unit_Class,
        });
        if (result) {
            advanceRentCalculation({ rentPerMonth }, result)
        }
    }
    const handleTermChange = async (e) => {
        const term = e.target.value;
        const today = new Date();
        let periodFrom = today;
        let periodTo = new Date(today);

        if (term === "Short Term") {
            periodTo.setMonth(periodTo.getMonth() + 3);
            periodTo.setDate(periodTo.getDate() - 1);
        } else if (term === "Long Term" || term === "Less than one Year") {
            periodTo.setFullYear(periodTo.getFullYear() + 1);
            periodTo.setDate(periodTo.getDate() - 1);
        }
        const formattedFrom = formatDate(periodFrom);
        const formattedTo = formatDate(periodTo);
        const leaseTerm = calculateDaysBetween(formattedFrom, formattedTo);
        const params = new URLSearchParams();
        params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
        params.append('PeriodFrom', moment(formattedFrom).format("DD-MMM-YYYY"));
        params.append('PeriodTo', moment(formattedTo).format("DD-MMM-YYYY"));
        params.append('Commontext', formData?.Rent_Per_Month);
        const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
        let result = res?.data?.result?.data?.RentPerAnnum
        setFormData((prev) => ({
            ...prev,
            term,
            periodFrom: formattedFrom,
            periodto: formattedTo,
            Rent_Per_period: result,
            // Rent_Per_Annum: result,
            leaseTerm: leaseTerm.toString(),
        }));
        advanceRentCalculation({ leaseTerm }, result)
        setDatesEditable(true);
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        // Ensure the date is formatted correctly
        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Always 'DD-MMM-YYYY'

        const updatedDates = { ...formData, [name]: updatedValue };

        if (name === 'periodFrom' || name === 'periodto') {
            const from = name === 'periodFrom' ? updatedValue : formData.periodFrom;
            const to = name === 'periodto' ? updatedValue : formData.periodto;

            if (from && to) {
                const fromDate = moment(from, "DD-MMM-YYYY");
                const toDate = moment(to, "DD-MMM-YYYY");

                if (fromDate.isAfter(toDate)) {
                    toast?.warning('Period From date must be less than Period To date.');
                    return;
                }

                const params = new URLSearchParams();
                params.append('Action', tenantDetails?.tanent1Code?.value?.Category_Mix === "US Navy" ? 'CalculateRentByMonthUSNAVY' : 'CalculateRentByMonth');
                params.append('PeriodFrom', fromDate.format("DD-MMM-YYYY"));
                params.append('PeriodTo', toDate.format("DD-MMM-YYYY"));
                params.append('Commontext', formData?.Rent_Per_Month);

                try {
                    const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
                    let result = res?.data?.result?.data?.RentPerAnnum;
                    const leaseTerm = calculateDaysBetween(from, to);
                    updatedDates.leaseTerm = leaseTerm.toString();
                    updatedDates.Rent_Per_period = result;
                    advanceRentCalculation({ result });
                } catch (error) {
                    console.error("API call failed", error);
                }
            }
        }

        setFormData(updatedDates);
    }
    const advanceRentCalculation = (rentPerMonths, result) => {
        setFormData((prev) => ({
            ...prev,
            advanceRent: 0,
        }));
        let rentPerMonth = rentPerMonths?.rentPerMonth ? rentPerMonths?.rentPerMonth : rentPerMonths?.perMonthval || formData?.Rent_Per_Month || 0
        let leaseTerm = rentPerMonths?.leaseTerm || formData?.leaseTerm || 0
        let rentPerPeriod = result || formData?.Rent_Per_period || 0
        const rentPerDay = parseFloat(rentPerPeriod / leaseTerm)
        let monthValue = rentPerMonths?.value === '' ? 0 : rentPerMonths?.value || formData?.month || 0
        let dayValue = rentPerMonths?.dayvalue === '' ? 0 : rentPerMonths?.dayvalue || formData?.days || 0
        let advanceAmount = (rentPerMonth * monthValue) + (dayValue * rentPerDay)
        setFormData((prev) => ({
            ...prev,
            advanceRent: advanceAmount,
        }));
    }
    const handleadvanceChange = (e) => {
        const { name, value } = e.target;
        if (name === 'month') {
            setFormData((prev) => ({
                ...prev,
                month: value,
            }));

            advanceRentCalculation({ value })
        } else if (name === 'days') {
            let dayvalue = value
            setFormData((prev) => ({
                ...prev,
                days: value,
            }));
            advanceRentCalculation({ dayvalue })
        }
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            if (!tenantDetails?.tanent1?.value) {
                toast.warning("Please Select Primary Tanent")
                setloader(false);
                return
                // } else if (!tenantDetails?.broker?.label) {
                //     toast.warning("Please Select Broker")
                //     setloader(false);
                //     return
            } else if (!tenantDetails?.prpManager?.label) {
                toast.warning("Please Select prpManager")
                setloader(false);
                return
            } else if (!tenantDetails?.type?.label) {
                toast.warning("Please Select type")
                setloader(false);
                return
            } else if (!tenantDetails?.agent?.label) {
                toast.warning("Please Select agent")
                setloader(false);
                return
            } else if (!entries?.[0]?.Property?.label) {
                toast.warning("Please Select Units ")
                setloader(false);
                return
            } else if (formData?.Property?.label || formData?.Unit?.label) {
                toast.warning(editIndex !== null ? "Please click Update to save the current unit details before saving" : "Please click Add to save the current unit details before saving")
                setloader(false);
                return
            }
            let hasInvalidUnit = false;

            // Validate all entries first
            for (const item of entries) {
                const params = new URLSearchParams();
                params.append('Action', 'CheckUnitAvbSaveValidation');
                params.append('UnitNo', item?.Unit?.label);
                params.append('PropertyNo', item?.Property?.value);

                const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);

                if (res?.data?.result?.data?.cnt > 0) {
                    toast.warning(`Selected Unit ${item?.Unit?.label} Already Existed, in Given ${item?.periodFrom} to ${item?.periodto}`);
                    hasInvalidUnit = true;
                }
            }

            // If any unit was invalid, stop here
            if (hasInvalidUnit) {
                setloader(false);
                return;
            }

            // Helper function for month diff


            // Build lease reservation list
            const leaseReservationMasterlst = entries.map((item, index) => {
                const leaseTermInMonths = getMonthDiff(item?.periodFrom, item?.periodto);
                return {
                    leaseNo: leaseData?.lease_No || leaseData?.leaseNo,
                    group_Id: leaseData?.group_Id || leaseData?.groupId,
                    recordId: leaseda?.Record_Id,
                    cust1_No: tenantDetails?.tanent1?.value || "0",
                    cust1_Name: tenantDetails?.tanent1?.label || "0",
                    cust2_No: tenantDetails?.tanent2?.value || "0",
                    cust2_Name: tenantDetails?.tanent2?.label || "0",
                    custPri_ContactNo: tenantDetails?.tanent1Code?.value?.MainContactno || "0",
                    custPri_Email: tenantDetails?.tanent1Code?.value?.Email_id || "0",
                    custPri_PassportID: "0",
                    custPri_Nationality: tenantDetails?.tanent1Code?.value?.Nationality || "0",
                    custPri_VatRegNo: "0",
                    custJoint_CustNo: tenantDetails?.tanent2Code?.value?.Customer_no || "0",
                    custJoint_CustName: tenantDetails?.tanent2Code?.value?.Customer_Name || "0",
                    custJoint_ContactNo: tenantDetails?.tanent2Code?.value?.MainContactno || "0",
                    custJoint_Email: tenantDetails?.tanent2Code?.value?.Email_id || "0",
                    custJoint_PassportID: "0",
                    custJoint_Nationality: tenantDetails?.tanent2Code?.value?.Nationality || "0",
                    custJoint_VatRegNo: "0",
                    // Agent Passes in Sale Person
                    salesPerson: tenantDetails?.agent?.label,
                    // Broker Passes in Agent
                    agent: tenantDetails?.broker?.label || "0",
                    tenantMoveType: tenantDetails?.type?.label,
                    propManager: tenantDetails?.prpManager?.label,
                    package: tenantDetails?.package?.label,
                    rentPerAnnum: item?.Rent_Per_Annum.toString(),
                    leasing_Fee: item?.Tenant_Commission.toString(),
                    service_Charge: item?.serviceCharges.toString() || "0",
                    // Rent free amount in advance
                    advance: item?.rentFree.toString(),
                    security_Deposit: item?.Security_Deposit.toString(),
                    misc_Charges: "0",
                    dewa: "0",
                    shopFit_Deposit: item?.Parking_Price.toString(),
                    leaseTerm: item?.leaseTerm,
                    leaseTermInMonths: leaseTermInMonths?.toString(),
                    rentPaymentTerm: "0",
                    paymentTermNoOfChqs: leaseTermInMonths,
                    // date
                    rentCommencementDate: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                    shopFitPeriod: "0",
                    anticipatedPremisesHandoverDate: "0",
                    anticipatedOpeningDate: "0",
                    status: "Lease Reserved",
                    pay_Option: "Group",
                    serviceChargeIncrease_Remarks: "0",
                    advHandoverNotice: "0",
                    handoverNotice: "0",
                    premisesHandoverDate: "0",
                    advNoticeOpening: "0",
                    mallOpeningDate: "0",
                    longStopDate: "0",
                    insurancePolicy: "0",
                    insuredAmount: "0",
                    addendum: "0",
                    rentPI: item?.Rent_Per_Annum.toString(),
                    rentPI_Years: item?.Rent_Month.toString(),
                    remarks: item?.remarks2 || "0",
                    rentPI_Remarks: item?.remarks3.toString() || "0",
                    tenantManual: "0",
                    tenantManualDate: "01-Jan-1900",
                    franchiseAgreement: "0",
                    franchiseExpDate: "01-Jan-1900",
                    franchiseRemarks: "0",
                    districtCooling: "0",
                    portableWater: tenantDetails?.type?.label,
                    totalArea: item?.Total_Area.toString(),
                    totalPrice: item?.Rent_Per_period.toString(),
                    totalPriceByUser: item?.Rent_Per_period.toString(),
                    exp1: item?.Landlord,
                    exp2: "0",
                    exp3: "0",
                    exp4: moment(item?.transDate).format("DD-MMM-YYYY"),
                    exp5: "0",
                    exp6: "0",
                    exp7: item?.Unit_Class,
                    exp8: item?.Ref_No,
                    exp9: item?.Rent_Per_Annum.toString(),
                    exp10: "Long Term",
                    exp11: item?.electricty || "0",
                    // Rent per month taxtbox value
                    exp12: item?.Rent_Per_Month.toString(),
                    exp13: item?.advanceRent.toString(),
                    exp14: item?.month?.toString(),
                    // Variable Charges
                    exp15: "0",
                    exp16: tenantDetails?.prpManager?.label,
                    // exp17: tenantDetails?.package?.label,
                    exp17: item?.electrictType === "Inclusive" ? "1" : "0" || "0",
                    exp18: item?.internet === true ? "1" : "0" || "0",
                    exp19: item?.term,
                    // Days Dropdown 
                    exp20: item?.days?.toString() || "0",
                    modified_By: userName,
                    modified_On: currentDatetimeUTC,
                    seriesNo: "0",
                    discountPercent: "0",
                    discount: "0",
                    taxCode: "0",
                    taxInclusive: "0",
                    vatPercent: "0",
                    stPercent: "0",
                    st: "0",
                    vat: "0",
                    rent: item?.Rent_Per_period?.toString(),
                    total: item?.Rent_Per_period?.toString(),
                    propertyNo: item?.Property?.value,
                    propertyName: item?.Property?.label,
                    unitNo: item?.Unit?.label,
                    unitRefNo: item?.Ref_No,
                    unitClass: item?.Unit_Class,
                    taxPercent: "0",
                    landlord: item?.Landlord,
                    municipalityNo: item?.MuncAcNo,
                    lease_Date: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                    lease_Expiry: moment(item?.periodto).format("DD-MMM-YYYY"),
                    category_Mix: "0",
                    property_Id: item?.Property?.value,
                    financialPosting: false,
                    groupPayment: true,
                    groupLeaseNo: true,
                    psOtherPayment: true,
                    installmentInvoice: false,
                    otherPaymentInvoice: true
                };
            });

            const body = {
                leaseReservationMain: {
                    leaseReservationMasterlst,
                    validateMeassage: datamsg
                }
            };

            const postRes = await apiService.put('GET_RESERV_EDIT', body);

            if (postRes?.data?.statusCode === 201) {
                if (postRes?.data?.result?.leaseNo && postRes?.data?.result?.groupId) {
                    toast.success(`${postRes?.data?.result?.leaseNo} Updated successfully`);
                    setloader(false);
                    navigate('/Lease/Management/Lease/Reservation')
                } else {
                    toast.warning("Please Try again")
                    setloader(false);
                }
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant?.text, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    };
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant?.value, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    };
    const handleElectChange = async (e) => {
        const term = e.target.value;
        setFormData((prev) => ({
            ...prev,
            electrictType: term,
            internet: true,
        }));
    }
    const handleInterNetChange = async (e) => {
        setFormData((prev) => ({
            ...prev,
            internet: e,
        }));
    }
    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Reservation</h6></div>
            <div className='d-flex justify-content-between border-box2 p-3' style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills start overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Tenant Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                </div>
                <div className='d-flex gap-1'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2 w-50'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-2 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnRed flex-end gap-2 w-50'>
                        <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                    <div className='mainbtnSecondary flex-end gap-2 w-50' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Primary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${FilterTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                            <AsyncPaginate
                                                className="p-0 w-100"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                loadOptions={loadOptionsName}
                                                value={tenantDetails?.tanent1}
                                                onChange={(selectedOption) => handleCust1Change(selectedOption)}
                                                additional={{ page: 0 }}
                                                isDisabled={leaseData?.approved}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <AsyncPaginate
                                                className="p-0 w-50"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                loadOptions={loadOptions}
                                                value={tenantDetails.tanent1Code}
                                                onChange={(selectedOption) => handleCust1CodeChange(selectedOption)}
                                                additional={{ page: 0 }}
                                                isDisabled={leaseData?.approved}
                                            />
                                            <div className='text-warning px-2 center' style={{ color: "#ffd24b", fontSize: "14px", fontWeight: "500" }}>{tenantDetails?.tanent1Code?.value?.Category_Mix || "---"}</div>
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent1Code?.value?.MainContactno} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent1Code?.value?.Email_id} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent1Code?.value?.TradeLicNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent1Code?.value?.Nationality} readOnly />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setAgentTab(!AgentTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Secondary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${AgentTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${AgentTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${AgentTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                            <AsyncPaginate
                                                className="p-0 w-100"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                value={tenantDetails?.tanent2}
                                                loadOptions={loadOptionsName}
                                                onChange={(selectedOption) => handleCust2Change(selectedOption)}
                                                additional={{ page: 0 }}
                                                isDisabled={leaseData?.approved}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <AsyncPaginate
                                                className="p-0 w-100"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                                        color: "#000",
                                                        ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                                    }),
                                                }}
                                                loadOptions={loadOptions}
                                                value={tenantDetails.tanent2Code}
                                                onChange={(selectedOption) => handleCust2CodeChange(selectedOption)}
                                                additional={{ page: 0 }}
                                                isDisabled={leaseData?.approved}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent2Code?.value?.MainContactno} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent2Code?.value?.Email_id} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent2Code?.value?.TradeLicNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent2Code?.value?.Nationality} readOnly />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setSecondaryTab(!SecondaryTab)}>
                            <div className='param-label pt-1 col-2'>Agent Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${SecondaryTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${SecondaryTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${SecondaryTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Agent</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.agent}
                                                isDisabled={leaseData?.approved}
                                                options={AgentList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleAgentChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Prp Manager</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.prpManager}
                                                isDisabled={leaseData?.approved}
                                                options={ManagerList?.map((cost) => ({ value: cost, label: cost?.text }))}
                                                onChange={(selectedOption) => handleManagerChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                isClearable
                                                value={tenantDetails?.broker}
                                                isDisabled={leaseData?.approved}
                                                options={BrokerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Package</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.package}
                                                isDisabled={leaseData?.approved}
                                                options={PackageList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handlePackageChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Type</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.type}
                                                isDisabled={leaseData?.approved}
                                                options={TypeList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className="cost-center-section my-3">
                    <div className="d-flex cursor-pointer slide-header"
                        onClick={() => setUnitRent(!unitRent)}>
                        <div className='param-label pt-1'>Unit Rent Details</div>
                        <IoIosArrowForward
                            size={30}
                            className={`arrow fade-rotate ${unitRent ? "open" : ""}`}
                        />
                    </div>
                    <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                        <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                            <div className="form-group grid-contain ">
                                {/* PropertNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        isDisabled={leaseData?.approved}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Property}
                                        options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit Ref No</label>
                                    <input type="text" className="p-2 form-control w-75" name="bedRooms"
                                        value={formData.Ref_No} disabled />
                                    <div className='text-bold center text-warning'>{formData?.Unit_Class}</div>
                                </div>
                                <div className="d-flex gap-3 justify-content-between" >
                                    <div className='gap-3 d-flex center'>
                                        {["Inclusive", "Exclusive"].map((label) => (
                                            <div className="form-check" key={label}>
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="electrictType"
                                                    value={label}
                                                    checked={formData.electrictType === label}
                                                    onChange={handleElectChange}
                                                />
                                                <label className="form-check-label">{label}</label>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='gap-3 center '>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            id="internet" style={{ width: "20px", height: "20px" }}
                                            name="internet"
                                            disabled={formData?.electrictType === "Inclusive"}
                                            checked={formData?.internet}
                                            onChange={(e) => handleInterNetChange(e.target.checked)}
                                        />
                                        <label className='px-2'>Internet</label>
                                    </div>
                                </div>
                                {/* UnitNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit No *</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Unit}
                                        isDisabled={leaseData?.approved}
                                        options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handleUnitChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent for Period</label>
                                    <input type="number" className="p-2 form-control w-75" name="Rent_Per_period" disabled
                                        value={Number(formData.Rent_Per_period)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Electrical Consumption</label>
                                    <input type="number" className="p-2 form-control w-75" name="electricty"
                                        disabled={leaseData?.approved}
                                        value={formData.electricty} onChange={handleChange} />
                                    <div className='center text-bold text-primary'>{(formData?.Rent_Per_Annum || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* Total Area */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Area</label>
                                    <input type="text" className="p-2 form-control w-75" name="noCommunity"
                                        value={formData.Total_Area} disabled />
                                </div>
                                {/* terms */}
                                <div className="d-flex gap-3 mb-3">
                                    {["Short Term", "Long Term", "Less than one Year"].map((label) => (
                                        <div className="form-check" key={label}>
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                name="term"
                                                value={label}
                                                // disabled={label === "Short Term"}
                                                disabled={leaseData?.approved}
                                                checked={formData.term === label}
                                                onChange={handleTermChange}
                                            />
                                            <label className="form-check-label">{label}</label>
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Month</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-75"
                                        name="Rent_Per_Month"
                                        disabled={leaseData?.approved}
                                        value={formData.Rent_Per_Month}
                                        // min={Number(formData?.Rent_Month || 0)}
                                        onChange={handleChange}
                                    // onBlur={(e) => {
                                    //     const minRent = Number(formData?.Rent_Month || 0);

                                    //     if (Number(e.target.value) < minRent) {
                                    //         setFormData((prev) => ({
                                    //             ...prev,
                                    //             Rent_Per_Month: minRent,
                                    //         }));
                                    //     }
                                    // }}
                                    />
                                    <div className='center text-primary'>{(formData?.Rent_Month || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* advance rend */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Bedroom(s)</label>
                                    <input type="email" className="p-2 form-control w-75" name="Bedrooms"
                                        value={formData.Bedrooms} disabled />
                                </div>
                                {/* transdate */}
                                <div className="d-flex">
                                    <label className="form-label pt-1 text-danger">TransDate</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData?.transDate}
                                        onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        disabled={leaseData?.approved}
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                                    <input type="number" className="p-2 form-control w-75" name="Security_Deposit" disabled={leaseData?.approved}
                                        value={formData.Security_Deposit} onChange={handleChange} />
                                </div>
                                {/*  */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking</label>
                                    <input type="text" className="p-2 form-control w-75" name="Parking"
                                        value={formData.Parking} disabled />
                                </div>
                                {/* period from */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period From</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodFrom ? new Date(formData.periodFrom) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodFrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                        disabled={!datesEditable}
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Service Charges</label>
                                    <input type="number" className="p-2 form-control w-100" name="serviceCharges"
                                        value={formData.serviceCharges} disabled onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">LandLoard</label>
                                    <input type="text" className="p-2 form-control w-75" name="Landlord"
                                        value={formData.Landlord} disabled onChange={handleChange} />
                                </div>
                                {/* period to */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period To</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodto ? new Date(formData.periodto) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                        disabled={!datesEditable}
                                    />
                                </div>
                                <div className="d-flex gap-2">
                                    <label className="form-label pt-1">Advance Rent</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-25"
                                        name="advanceRent"
                                        value={Number(formData.advanceRent)?.toFixed(currencyPrecision?.decimalNumbers)}
                                        disabled
                                    />
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.month}
                                        name='month'
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Month</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.days}
                                        name='days'
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Days</option>
                                        {[...Array(31)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Munc A/C No</label>
                                    <input type="text" className="p-2 form-control w-75" name="MuncAcNo"
                                        value={formData.MuncAcNo} disabled onChange={handleChange} />
                                </div>
                                {/* lease term */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Lease Term</label>
                                    <input
                                        type="text"
                                        className="p-2 form-control w-75"
                                        name="leaseTerm"
                                        value={formData.leaseTerm}
                                        readOnly
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Advance Payment</label>
                                    <input type="number" className="p-2 form-control w-75" name="Security_Deposit" disabled
                                        value={(Number(formData.advanceRent || 0) + Number(formData.Security_Deposit || 0)).toFixed(currencyPrecision?.decimalNumbers)} />
                                </div>
                                {/* rent free */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent Free Amount</label>
                                    <input type="text" className="p-2 form-control w-75" name="rentFree" disabled={leaseData?.approved}
                                        value={formData.rentFree} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Reservation/ Agreement</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.reservation}
                                        options={remarksList?.map((cost) => ({ value: cost, label: cost?.value }))}
                                        onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking Charges</label>
                                    <input type="number" className="p-2 form-control w-75" name="Parking_Price" disabled={leaseData?.approved}
                                        value={formData.Parking_Price} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <textarea type="text" className="form-control" name={formData?.reservation?.label === "Lease Agreement Remarks" ? "remarks3" : "remarks2"}
                                        value={formData?.reservation?.label === "Lease Agreement Remarks" ? formData.remarks3 : formData.remarks2} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <textarea type="text" className="form-control" name="remarks1"
                                        value={formData.remarks1} onChange={handleChange} placeholder='Narration' />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Commission</label>
                                    <input type="number" className="p-2 form-control w-75" name="Tenant_Commission" disabled={leaseData?.approved}
                                        value={formData.Tenant_Commission} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    {editIndex !== null ?
                                        <button className="btn btn-primary my-3" onClick={handleUpdate}>
                                            {'Update'}
                                        </button> :
                                        <button className="btn btn-primary my-3" onClick={handleAddMore}>
                                            Add
                                        </button>
                                    }
                                </div>
                                <div></div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Admin/Leasing Fee</label>
                                    <input type="number" className="p-2 form-control w-75" name="leaseFee" disabled={leaseData?.approved}
                                        value={formData.leaseFee} onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className=" table-container  mt-4" style={{ overflowX: 'auto', height: "400px" }}>
                            <table>
                                <thead className='dynoTable p-0 m-0' >
                                    <tr>
                                        <th>Actions</th>
                                        <th>Property</th>
                                        <th>Unit</th>
                                        <th>Total Area</th>
                                        <th>Trans Date</th>
                                        <th>Period From</th>
                                        <th>Period To</th>
                                        <th>Rent for Period</th>
                                        <th>Security Deposit</th>
                                        <th>Ejari Charges</th>
                                        <th>Service Charges</th>
                                        <th>Parking Price</th>
                                        <th>Admin Fee</th>
                                        <th>Rent Free Amount</th>
                                        <th>No of Installments</th>
                                        <th>Lease Term</th>
                                        <th>Reservation/ Agreement</th>
                                        <th>Remarks</th>
                                        <th>Remarks PI</th>
                                    </tr>
                                </thead>
                                <tbody className='p-0 m-0'>
                                    {entries?.map((entry, index) => (
                                        <tr key={index} className='p-0 m-0'>
                                            <td className='gap-3 d-flex'>
                                                <div className='pt-2' onClick={() => handleDelete(index)}>
                                                    <MdDelete size={25} />
                                                </div>
                                                <div className='pt-2' onClick={() => handleEdit(index)}>
                                                    <FiEdit size={25} />
                                                </div>
                                            </td>
                                            <td className='m-0 p-0'><input className="p-1" value={entry.Property?.label} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Unit?.label} disabled style={{ width: "100px" }} /></td>
                                            <td><input className="p-1" value={entry.Total_Area} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.transDate).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodFrom).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodto).format("DD-MMM-YYYY")} disabled style={{ width: "120px" }} /></td>
                                            <td><input className="p-1" value={entry.Rent_Per_period?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={entry.Security_Deposit} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={0.000} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={entry.serviceCharges} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={entry.Parking_Price} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={entry.leaseFee} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={entry.rentFree} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Installments} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.leaseTerm} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={entry.reservation?.label} disabled /></td>
                                            <td><input className="p-1" value={entry.remarks2} disabled style={{ width: "fit-content" }} /></td>
                                            <td><input className="p-1" value={entry.remarks3} disabled style={{ width: "fit-content" }} /></td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            <Modal size="md"
                show={msgModal} onHide={() => setmsgModal(false)}
                backdrop="static"
                contentLabel='Confirmation Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>{datamsg}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        Do you want to add Unit
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={dataset}>Ok</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default UpdateLeaseReservation;
